import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var GeocodeService = /** @class */ (function () {
    function GeocodeService(http) {
        this.http = http;
        this.searchExtent = {
            xmin: -8963167.0999474,
            ymin: 4815933.74691319,
            xmax: -8306549.08350328,
            ymax: 5238680.50536529,
            spatialReference: { wkid: 102100 }
        };
        this.categories = ['Address', 'POI'].join(',');
    }
    GeocodeService.prototype.suggest = function (text, maxSuggestions) {
        var url = environment.geocodeServerUrl + '/suggest?';
        url += this.buildQueryString({
            text: text,
            searchExtent: JSON.stringify(this.searchExtent),
            category: this.categories,
            maxSuggestions: maxSuggestions === null ? undefined : maxSuggestions,
            location: environment.geocodeStartingLocation,
            f: 'json'
        });
        return this.http.get(url).pipe(catchError(this.handleError.bind(this)));
    };
    GeocodeService.prototype.find = function (text, magicKey) {
        var url = environment.geocodeServerUrl + '/findAddressCandidates?';
        var params = {
            address: text,
            countryCode: 'USA',
            outSR: 102100,
            searchExtent: JSON.stringify(this.searchExtent),
            f: 'json'
        };
        if (magicKey) {
            params.magicKey = magicKey;
        }
        url += this.buildQueryString(params);
        return this.http.get(url).pipe(catchError(this.handleError.bind(this)));
    };
    GeocodeService.prototype.buildQueryString = function (params) {
        var str = [];
        for (var p in params) {
            if (params.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
            }
        }
        return str.join('&');
    };
    GeocodeService.prototype.handleError = function (err) {
        var errorMessage;
        if (err.error instanceof ErrorEvent) {
            // client-side or network
            errorMessage = "An error occured: " + err.error.message;
        }
        else {
            // backend returned an unsuccessful response code.
            errorMessage = "Backend return code " + err.status + ": " + err.body.error;
        }
        console.error(err);
        return throwError(errorMessage);
    };
    GeocodeService.ngInjectableDef = i0.defineInjectable({ factory: function GeocodeService_Factory() { return new GeocodeService(i0.inject(i1.HttpClient)); }, token: GeocodeService, providedIn: "root" });
    return GeocodeService;
}());
export { GeocodeService };
